<div class="zoom-container">
    <div class="close-icon-container d-flex align-items-center">
        <!-- close icon -->
        <img [src]="IMAGE_URLS.closeIconDark" class="close-icon" (click)="onClose()" />
    </div>
    <div>
        <ng-content></ng-content>
    </div>
</div>